import React, { useContext, useEffect, useState } from 'react';

import HiddenDatasetLabel from 'components/HiddenDatasetLabel';
import BaseViewsContext from '../../../../../../contexts/BaseViewsContext';
import AnalyticsContext from '../../../../../../contexts/AnalyticsContext';
import SingleUseMetricPopupContext from '../../../../../../contexts/SingleUseMetricPopupContext';

const useDataSourceOptions = ({
  setDataSource,
  onDatasetChanged,
  setDrillDowns,
}: {
  setDataSource: React.Dispatch<React.SetStateAction<string | undefined>>;
  onDatasetChanged: () => void;
  setDrillDowns: React.Dispatch<React.SetStateAction<FilterPlateType[]>>;
}) => {
  const { dataTypeOptions } = useContext(BaseViewsContext);
  const { trackEvent } = useContext(AnalyticsContext);
  const { datasetRedList } = useContext(SingleUseMetricPopupContext);
  const [dataSourceOptions, setDataSourceOptions] = useState<DropdownOption[]>(
    [],
  );

  useEffect(() => {
    setDataSourceOptions(
      dataTypeOptions
        .filter(({ value }) => !datasetRedList?.includes(value))
        .map(({ label, value, isHidden }) => {
          return {
            label,
            value,
            ...(isHidden
              ? { renderLabel: () => <HiddenDatasetLabel label={label} /> }
              : {}),
            onSelected: () => {
              const dataset = value;
              setDataSource(dataset);
              trackEvent('Metric Builder - Datasource selected', {
                dataset,
              });
              onDatasetChanged();
            },
          };
        }),
    );
  }, [
    dataTypeOptions,
    datasetRedList,
    onDatasetChanged,
    setDataSource,
    setDrillDowns,
    trackEvent,
  ]);

  return dataSourceOptions;
};

export default useDataSourceOptions;
